import React, { useState, useEffect } from "react";
import Cookies from "js-cookie";
import { Link } from "react-router-dom";
import { useAuth } from "../../../Context/AuthProvider";
import {  ChartColumn, GraphicalDataFlow, Logout, Password, User, UserCertification } from "@carbon/icons-react";
import axios from "axios";
import { url } from "../../../Constant";
import { toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import { checkPermissions } from "../../../Utils/PermissionFunctions";
// import "./Sidebar.css";





const Sidebar = () => {
  const [userIsLoggedIn, setUserIsLoggedIn] = useState(true);
  let inactivityTimer;

  const { auth } = useAuth();
  
  const handleSwitcher = (val) => {
    sessionStorage.setItem("ct_licked", val);
  };

  const handleLogout = () => {
    // Make a POST request to the logout endpoint
    axios
      .post(
        url + `auth/logout`,
        {
          vpbx_id: auth.vpbx_id,
        },
        {
          headers: {
            Authorization: `Bearer ${auth.token}`,
            "Content-Type": "application/json",
          },
        }
      )
      .then((response) => {
        if (response.status === 200) {
          // Successfully logged out, perform any additional actions here
          sessionStorage.clear("/");
          localStorage.clear("/");
          Cookies.remove(
            "YUTETOLPBG-ASY1BSBD#!ASDNMlPOS--_AWQQWyADIURYBDSF092B34BSDSEWEWFELPOWD",
            { path: "/" }
          );
          // Redirect to the home page or any other destination
          window.location.href = "/";
        } else {
          // Handle the case where logout failed (e.g., show an error message)
          console.error("Logout failed");
        }
      })
      .catch((error) => {
        // Handle any network or other errors
        console.error("Network error:", error);
      });
  };

  // Function to reset the inactivity timer
  const resetInactivityTimer = () => {
    clearTimeout(inactivityTimer);
    inactivityTimer = setTimeout(() => {
      // Show a toast message when the user is logged out
      const toastId = toast("User is logged out due to inactivity", {
        position: toast.POSITION.TOP_RIGHT,
        autoClose: 5000, // Increase the autoClose time to 5000 milliseconds (5 seconds)
        type: "error",
      });

      // Wait for the toast to close before logging out the user
      setTimeout(() => {
        toast.dismiss(toastId);
        sessionStorage.clear();
        setUserIsLoggedIn(false);
        handleLogout();
      }, 5000);
    }, 10 * 60 * 1000); // 10 minutes in milliseconds
  };

  // Event listeners to reset the inactivity timer
  useEffect(() => {
    resetInactivityTimer();

    const activityEvents = ["mousemove", "keydown", "click"];

    const resetTimerOnActivity = () => {
      resetInactivityTimer();
    };

    activityEvents.forEach((event) => {
      window.addEventListener(event, resetTimerOnActivity);
    });

    return () => {
      activityEvents.forEach((event) => {
        window.removeEventListener(event, resetTimerOnActivity);
      });
    };
  }, []);

  // Render navigation items based on user role and permissions
  const renderNavItems = () => {
    return (
      <>
        {/* Home/Dashboard Link */}
        {(auth.role === "1" || auth.role === "2" || checkPermissions("dashboard")) && (
          <li>
            <Link
              className="character-btn"
              to="/dashboard"
              uk-tooltip="title: Home; pos: right"
            >
              <img
                src="/assets/images/zong/nav-home.svg"
                uk-svg=""
                alt="Home"
              />
            </Link>
          </li>
        )}

        {/* Admin/Manager Role Items */}
        {(auth.role === "2" || auth.role === "3") && (
          <>
            {/* Call Records */}
            {(auth.role === "2" || checkPermissions("call-records")) && (
              <li>
                <Link
                  className="character-btn"
                  to="/call-records"
                  uk-tooltip="title: Call Recorder; pos: right"
                >
                  <img
                    src="/assets/images/zong/nav-Callrecords.svg"
                    uk-svg=""
                    alt="Call Records"
                  />
                </Link>
              </li>
            )}


            {(auth.role === "2" || checkPermissions("call-records")) && (
              <li>
                <Link
                  className="character-btn"                  
                >
                  <ChartColumn size={20} />
                  <div uk-dropdown = "pos: right-top" className="uk-dropdown">
                    <ul className="uk-nav uk-dropdown-nav nav-dropdown">
                      <li className="uk-active">GRAPHS</li>

                      <li className="uk-active">
                        <Link to = "/top-agents">
                          Top agents
                        </Link>
                      </li>

                      <li className="uk-active">
                        <Link to = "/graphs">
                          Graphs
                        </Link>
                      </li>
                    </ul>
                  </div>
                </Link>
              </li>
            )}

            {/* VPBX Manager */}
            {(auth.role === "2" || checkPermissions("vpbx-manager")) && (
              <li>
                <Link className="character-btn">
                  <img
                    src="/assets/images/zong/nav-VPBXmanager.svg"
                    uk-svg=""
                    alt="VPBX Manager"
                  />
                </Link>
                <div uk-dropdown="pos: right-top">
                  <ul className="uk-nav uk-dropdown-nav nav-dropdown">
                    <li className="uk-active">VPBX MANAGER</li>
                    
                    {/* IVR Flow */}
                    {(auth.role === "2" || checkPermissions("ivr-flow")) && (
                      <li>
                        <Link to="/ivr-flow">IVR flow</Link>
                      </li>
                    )}
                    
                    {/* Extensions */}
                    {(auth.role === "2" || checkPermissions("extensions")) && (
                      <li>
                        <Link to="/extensions">Extensions</Link>
                      </li>
                    )}
                    
                    {/* Forwarding */}
                    {(auth.role === "2" || checkPermissions("Forwarding")) && (
                      <li>
                        <Link to="/call-forwarding">Forwarding</Link>
                      </li>
                    )}
                    
                    {/* Conferencing */}
                    {(auth.role === "2" || checkPermissions("conferencing")) && (
                      <li>
                        <Link to="/call-conferencing">Conferencing</Link>
                      </li>
                    )}
                    
                    {/* List Manager */}
                    {(auth.role === "2" || checkPermissions("list-manager")) && (
                      <li>
                        <Link to="/list-manager">List manager</Link>
                      </li>
                    )}
                    
                    {/* Sound Settings */}
                    {(auth.role === "2" || checkPermissions("sound-settings")) && (
                      <li>
                        <Link to="/sound-setting">Sound settings</Link>
                      </li>
                    )}
                    
                    {/* Hours */}
                    {(auth.role === "2" || checkPermissions("hours")) && (
                      <li>
                        <Link to="/hour">Hours</Link>
                      </li>
                    )}
                    
                    {/* Customized IVR */}
                    {(auth.role === "2" || checkPermissions("customized-ivr")) && (
                      <li>
                        <Link to="/customized-ivr">Customized IVR</Link>
                      </li>
                    )}
                    
                    {/* Queue */}
                    {(auth.role === "2" || checkPermissions("queue")) && (
                      <li>
                        <Link to="/queue">Queue</Link>
                      </li>
                    )}
                    
                    {/* Prompts (Admin only) */}
                    {auth.role === "2" && (
                      <li>
                        <Link to="/prompt">Prompts</Link>
                      </li>
                    )}
                  </ul>
                </div>
              </li>
            )}

            {/* Call Initialize */}
            {auth.call_initiated === "1" && (
              <li>
                <Link
                  className="character-btn"
                  to="/call-initialize"
                  uk-tooltip="title: Call Initialize; pos: right"
                >
                  <img
                    src="/assets/images/zong/webhook.svg"
                    uk-svg=""
                    alt="Call Initialize"
                    style={{ width: "27px" }}
                  />
                </Link>
              </li>
            )}
          </>
        )}

        {/* Super Admin Role Items */}
        {auth.role === "1" && (
          <li>
            <Link className="character-btn">
              <img
                src="/assets/images/zong/nav-VPBXmanager.svg"
                uk-svg=""
                alt="Admin Panel"
              />
            </Link>
            <div uk-dropdown="pos: right-top">
              <ul className="uk-nav uk-dropdown-nav nav-dropdown">
                <li className="uk-active">VPBX MANAGER</li>
                <li>
                  <Link to="/companies">Companies</Link>
                </li>
                <li>
                  <Link to="/add-company">Add companies</Link>
                </li>
                <li>
                  <Link to="/packages">Packages</Link>
                </li>
                <li>
                  <Link to="/add-packages">Add packages</Link>
                </li>
                <li>
                  <Link to="/master-number">Master number DIOD</Link>
                </li>
                <li>
                  <Link to="/add-master-number">
                    Add Master number DIOD
                  </Link>
                </li>
              </ul>
            </div>
          </li>
        )}
      </>
    );
  };

  // Render profile and logout options
  const renderProfileOptions = () => {
    return (
      <>
        {/* Profile Menu for Manager Role */}
        {auth.role === "2" && (
          <li>
            <Link className="character-btn">
              <img
                className="profileSidebarImg"
                src="/assets/images/zong/newavatr.png"
                uk-svg=""
                alt="Profile"
              />
            </Link>
            <div uk-dropdown="pos: right-top">
              <ul className="uk-nav uk-dropdown-nav nav-dropdown">
                <li className="uk-active">PROFILE</li>
                <li>
                  <Link className="character-btn" to="/password-change">
                    <Password /> Password Change
                  </Link>
                  <Link className="character-btn" to="/update-profile">
                    <UserCertification /> Update Profile
                  </Link>
                  <Link className="character-btn" to="/user">
                    <User /> User Manager
                  </Link>
                </li>
              </ul>
            </div>
          </li>
        )}

        {/* Logout Button */}
        <li uk-tooltip="title: Logout; pos: right">
          <Link className="character-btn">
            <button
              onClick={handleLogout}
              style={{
                background: "none",
                outline: "none",
                cursor: "pointer",
                border: "none",
              }}
            >
              <Logout />
            </button>
          </Link>
        </li>
      </>
    );
  };

  return (
    <>
      {userIsLoggedIn ? (
        <nav className="sideNav">
          <div className="logowrp">
            <img src="/assets/images/zong/logo.svg" uk-svg="" alt="Logo" />
          </div>
          <div className="navwrp">
            <ul>
              {renderNavItems()}
            </ul>
            <ul className="scnd-navwrp">
              {renderProfileOptions()}
            </ul>
          </div>
        </nav>
      ) : (
        <nav className="sideNav">
          <div className="logowrp">
            <img src="/assets/images/zong/logo.svg" uk-svg="" alt="Logo" />
          </div>
          <div className="navwrp">
            <ul>
              <li>
                <Link
                  className="character-btn"
                  to="/dashboard"
                  uk-tooltip="title: Home; pos: right"
                >
                  <img
                    src="/assets/images/zong/nav-home.svg"
                    uk-svg=""
                    alt="Home"
                  />
                </Link>
              </li>
            </ul>
            <ul className="scnd-navwrp">
              <li>
                <Link className="character-btn">
                  <Password />
                </Link>
              </li>
              <li>
                <Link className="character-btn">
                  <img
                    className="profileSidebarImg"
                    src="/assets/images/zong/newavatr.png"
                    uk-svg=""
                    alt="Profile"
                  />
                </Link>
              </li>
              <li uk-tooltip="title: Logout; pos: right">
                <Link className="character-btn">
                  <button
                    onClick={handleLogout}
                    style={{
                      background: "none",
                      outline: "none",
                      cursor: "pointer",
                      border: "none",
                    }}
                  >
                    <Logout />
                  </button>
                </Link>
              </li>
            </ul>
          </div>
        </nav>
      )}
    </>
  );
};

export default Sidebar;
